<template>
    <div class="kgr-grid kgr-grid--gutters kgr-grid--inlineBlock animated fadeIn">
        <div
            v-for="dog in dogs"
            :key="dog.id"
            class="kgr-grid__cell app-gridCard container_child"
        >
            <div class="kgr-card">
                <div class="kgr-card__image">
                    <div class="kgr-profileImage kgr-profileImage--inline kgr-profileImage--sizeM">
                        <kgr-profile-image
                            :src="avatarUrl(dog)"
                            :alt="dog.name"
                        />
                    </div>
                </div>

                <h3
                    class="kgr-card__name child_name"
                >
                    <a
                        :href="`/backend/clubs/dogs/${dog.id}/show`"
                    >
                        {{ dog.name }}
                    </a>
                </h3>

                <div
                    class="kgr-card__contents"
                    style="overflow: hidden;"
                >
                    <div>
                        {{ dog.gender !== null ? $t(dog.gender) : $t('gender.u') }}
                    </div>
                    <div>
                        {{ dog.breed ? dog.breed.label : '' }}
                    </div>
                    <div>
                        {{ dog.breedSpecialization ? dog.breedSpecialization.label : '' }}
                    </div>
                    <div v-if="dog.dateOfBirth">
                        {{ $t('Wurfdatum') }}: {{ dog.dateOfBirth }}
                    </div>
                    <div v-if="dog.dateOfDeath">
                        {{ $t('Todesdatum') }}: {{ dog.dateOfDeath }}
                    </div>
                    <div v-if="dog.breedingBookNumber">
                        {{ $t('Zuchtbuchnummer') }}: {{ dog.breedingBookNumber }}
                    </div>
                    <div v-if="dog.chipNumber">
                        {{ $t('Chipnummer') }}: {{ dog.chipNumber }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DogRepository from '../../js/repository/DogRepository.js';
import ProfileImage from '../common/ProfileImage';

export default {
    components: {
        'kgr-profile-image': ProfileImage,
    },
    props: {
        dogs: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
        };
    },
    methods: {
        avatarUrl(dog) {
            return dog.hasAvatar ? DogRepository.avatarUrl(dog.id, dog.avatarFileName) : kgr.assetsUrls.clubityAvatarDogUnknown;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
